// extracted by mini-css-extract-plugin
export default {"wrong":"dNU43T8RIMqwulTuApq2gn7OoV-w5T4ZRUyIACrZZVF"};